import { completionEvent } from "../lib/completion-analytics";
import { useState } from "react";
import type { SeatCandidate } from "@anjabom/core";
import { seatCardImage } from "../lib/seat-card-image";
import { isAppsInTossChannel } from "../lib/channel";
export function ShareSeatImage({
	candidate,
	note = "",
}: {
	candidate: SeatCandidate;
	note?: string;
}) {
	const [message, setMessage] = useState(""),
		[image, setImage] = useState("");
	if (isAppsInTossChannel()) return null;
	async function share() {
		try {
			const blob = await seatCardImage(candidate, note),
				file = new File([blob], "anjabom-seat.png", { type: "image/png" });
			if (navigator.canShare?.({ files: [file] })) {
				await navigator.share({ files: [file], title: "앉아봄 좌석 카드" });
				completionEvent("share_completed", { method: "image" });
				setMessage("좌석 이미지를 공유했어요.");
			} else {
				const url = URL.createObjectURL(blob);
				setImage(url);
				const a = document.createElement("a");
				a.href = url;
				a.download = "anjabom-seat.png";
				a.click();
				completionEvent("share_completed", { method: "image" });
				setMessage(
					"이미지 저장을 요청했어요. 다운로드가 안 되면 이미지를 길게 눌러 저장해 주세요.",
				);
			}
		} catch (e) {
			if (e instanceof DOMException && e.name === "AbortError") return;
			setMessage(
				e instanceof Error
					? e.message
					: "이미지를 만들지 못했어요. 링크 공유를 이용해 주세요.",
			);
		}
	}
	return (
		<div className="stack">
			<button className="button" onClick={() => void share()}>
				좌석 카드 이미지로 저장하기
			</button>
			{image ? (
				<a href={image} target="_blank" rel="noreferrer">
					<img src={image} alt="저장할 좌석 카드 · 길게 눌러 저장" />
				</a>
			) : null}
			<p role="status">{message}</p>
		</div>
	);
}
